function isLabTop() {
  return window.matchMedia('(max-width: 1440px) and (min-width: 768px)')
    .matches;
}

export default isLabTop;
